import {
  findHighestContrastColor,
  getContrastRatio,
  getNumericStyleValue,
  parseColorString,
  realBackgroundColor,
  rgbaToString
} from "../index.js";
export class DragStyle {
  styleCache;
  backgroundCache;
  constructor() {
    this.styleCache = /* @__PURE__ */ new WeakMap();
    this.backgroundCache = /* @__PURE__ */ new WeakMap();
  }
  invalidateStyle(el) {
    this.styleCache.delete(el);
    this.backgroundCache.delete(el);
  }
  reset() {
    this.styleCache = /* @__PURE__ */ new WeakMap();
    this.backgroundCache = /* @__PURE__ */ new WeakMap();
  }
  getStyle(el, accentColor) {
    const cached = this.styleCache.get(el);
    if (cached) {
      return cached;
    }
    const style = this.getDraggableStyle(el, accentColor);
    this.styleCache.set(el, style);
    return style;
  }
  realBackgroundColor(el) {
    const transparent = "rgba(0, 0, 0, 0)";
    if (!el) {
      return transparent;
    }
    const cached = this.backgroundCache.get(el);
    if (cached) {
      return cached;
    }
    let bg = getComputedStyle(el).backgroundColor;
    if (bg === transparent || bg === "transparent") {
      bg = realBackgroundColor(el.parentElement);
    }
    this.backgroundCache.set(el, bg);
    return bg;
  }
  getDraggableStyle(el, accentColor) {
    const style = getComputedStyle(el);
    const radius = [
      getNumericStyleValue(style.borderTopLeftRadius, 0),
      getNumericStyleValue(style.borderTopRightRadius, 0),
      getNumericStyleValue(style.borderBottomRightRadius, 0),
      getNumericStyleValue(style.borderBottomLeftRadius, 0)
    ];
    const radiusMin = Math.min(...radius);
    const backgroundColorForSelection = parseColorString(
      realBackgroundColor(el.parentElement)
    );
    const contrastColor = findHighestContrastColor(
      [[255, 255, 255], accentColor],
      backgroundColorForSelection
    );
    const backgroundColor = parseColorString(realBackgroundColor(el));
    const textColor = findHighestContrastColor(
      [
        [0, 0, 0],
        [255, 255, 255]
      ],
      backgroundColor
    );
    const bg = backgroundColorForSelection || [255, 255, 255];
    const ratio = getContrastRatio(accentColor, bg);
    return {
      radius,
      radiusMin,
      radiusString: radius.map((v) => v + "px").join(" "),
      contrastColor: rgbaToString(contrastColor),
      contrastColorRGB: contrastColor,
      contrastColorTranslucent: rgbaToString(contrastColor, 0.25),
      textColor: rgbaToString(textColor),
      isInverted: ratio < 5
    };
  }
}
